import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { QRCodeCanvas } from 'qrcode.react';
import { Modal, Button } from '../../../../components'; // Ajuste o caminho conforme onde está seu Modal e Button
import { modalClose } from '../../../../layout/redux/layoutActions';

export default ({ url, nomeEstabelecimento, texto, textoSemUrl, title }) => {
  const dispatch = useDispatch();
  const { statusModal } = useSelector(state => state.layoutState);

  const sanitizeNomeArquivo = (nome) => {
    if (typeof nome !== 'string' || nome.trim() === '') {
      return 'estabelecimento';
    }
    return nome
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // remove acentos
      .replace(/\s+/g, '_');           // troca espaços por _
  };

  const canvasId = `qrcode-canvas-${sanitizeNomeArquivo(nomeEstabelecimento)}`;

  const downloadQRCode = () => {
    const canvasId = `qrcode-canvas-${sanitizeNomeArquivo(nomeEstabelecimento)}`;
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'application/octet-stream');
    const a = document.createElement('a');
    a.href = pngUrl;
    a.download = `qrcode_${sanitizeNomeArquivo(nomeEstabelecimento)}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  

  return (
    <Modal
      name="qrcode-tripadvisor"           // sem key aqui
      //title="Qrcode Download"
      title={title}
      size="medium"
      open={statusModal === "qrcode-tripadvisor"}
      close={() => dispatch(modalClose())}
      closeText="Fechar"
    >
      <div className="modal-content-qrcode" style={{ textAlign: "center" }}>
        <p style={{ marginBottom: "20px" }}>{texto}</p>
        {url ? (
          <QRCodeCanvas
            key={url}                     // ← somente aqui, na Canvas
            id={canvasId}
            value={url}
            size={400}
          />
        ) : (
          <p>{textoSemUrl}</p>
        )}
        <div style={{ marginTop: "20px" }}>
          <Button color="primary" onClick={downloadQRCode} type="btn" variant="outlined">
            Download
          </Button>
        </div>
      </div>
    </Modal>
  );
  
};
